import React, { useRef, useContext } from 'react';
import styled, { css } from 'styled-components';
import { Button } from './Button';
import { UiStateContext } from '../context/UiStateContext';

const StyledStickyValuationBar = styled.div`
  ${({ theme: { space, colors, layers, media, shadows } }) => css`
    width: 100%;
    position: fixed;
    bottom: 0;
    transition: top 0.3s;
    padding: ${space.md};
    background-color: ${colors.white.default};
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: ${space.sm};
    box-shadow: ${shadows.mediumTop};
    z-index: ${layers.stickyBar};
    > * {
      min-height: 66px;
    }
    button {
      flex-grow: 1;
    }
    @media (min-width: ${media.md}) {
      display: none;
    }
  `};
`;

export const StickyValuationBar = () => {
  const requestAValuationTriggerEl = useRef() as React.MutableRefObject<HTMLButtonElement>;
  const { setActiveBlade, setActiveBladeTriggerEl } = useContext(UiStateContext);
  const { heroOutOfView } = useContext(UiStateContext);
  // Handle Blades
  const handleOpenBlade = (bladeId, triggerEl) => {
    setActiveBlade(bladeId);
    setActiveBladeTriggerEl(triggerEl);
  };

  return (
    <>
      {heroOutOfView && (
        <StyledStickyValuationBar>
          <Button url="/branches/" label="Find a branch" variant="outline" type="button" />
          <Button
            label="Arrange a valuation"
            variant="solid"
            type="button"
            onClick={() => handleOpenBlade('propertyRequestAValuation', requestAValuationTriggerEl)}
            ref={requestAValuationTriggerEl}
          />
        </StyledStickyValuationBar>
      )}
    </>
  );
};
